import { useState, useEffect } from 'react'

// Définition complète de la checklist de gestion des examens
const CHECKLIST_DATA = [
  {
    id: 1,
    title: 'Collecte des données initiales',
    items: [
      {
        id: '1.1',
        title: 'Données administratives',
        subtasks: [
          { id: '1.1.1', text: 'Obtenir la liste définitive des cours', completed: false },
          { id: '1.1.2', text: 'Vérifier les modalités d\'évaluation pour chaque module (écrit, oral, pratique, projet)', completed: false },
          { id: '1.1.3', text: 'Confirmer la durée des examens', completed: false },
          { id: '1.1.4', text: 'Recueillir les besoins spécifiques (salles spécialisées, matériel)', completed: false },
          { id: '1.1.5', text: 'Vérifier les contraintes institutionnelles (jour fériés, événements majeurs)', completed: false },
          { id: '1.1.6', text: 'Collecter les disponibilités des enseignants (utopique)', completed: false }
        ]
      }
    ]
  },
  {
    id: 2,
    title: 'Définition du périmètre et des règles de planification',
    items: [
      {
        id: '2.0',
        text: 'Définir la période officielle d\'examens conformément au calendrier académique. Deja connu',
        completed: false
      },
      {
        id: '2.1',
        title: 'Règles pédagogiques',
        subtasks: [
          { id: '2.1.1', text: 'Limite du nombre d\'examens par jour', completed: false },
          { id: '2.1.2', text: 'Définition d\'un temps de pause minimal entre deux épreuves', completed: false }
        ]
      },
      {
        id: '2.2',
        title: 'Règles administratives',
        subtasks: [
          { id: '2.2.1', text: 'Respect des horaires institutionnels (début matin/après-midi)', completed: false },
          { id: '2.2.2', text: 'Priorisation des niveaux d\'études (par exemple : TPart puis PT)', completed: false }
        ]
      }
    ]
  },
  {
    id: 3,
    title: 'Préparation des ressources',
    items: [
      {
        id: '3.2',
        title: 'Surveillants et personnel',
        subtasks: [
          { id: '3.2.1', text: 'Évaluer les besoins en surveillants par session d\'examen', completed: false },
          { id: '3.2.2', text: 'Obtenir ou mettre à jour la base de données des surveillants', completed: false },
          { id: '3.2.3', text: 'Estimer les besoins en personnel administratif (accueil, sécurité, assistance technique)', completed: false }
        ]
      }
    ]
  },
  {
    id: 4,
    title: 'Construction du planning prévisionnel',
    items: [
      { id: '4.1', text: 'Placer en priorité les examens ayant des contraintes fortes (grandes cohortes, salles spécialisées)', completed: false },
      { id: '4.2', text: 'Positionner les autres examens en fonction des règles de charge et des disponibilités', completed: false },
      { id: '4.3', text: 'Bloquer les salles et créneaux associés', completed: false },
      { id: '4.4', text: 'Insérer les pauses réglementaires', completed: false },
      { id: '4.5', text: 'Ajouter les marges nécessaires pour les épreuves longues ou les installations matérielles', completed: false },
      { id: '4.6', text: 'Préparer une première version du planning consolidée par semestre, groupe et salle', completed: false }
    ]
  },
  {
    id: 5,
    title: 'Validation et itérations',
    items: [
      {
        id: '5.1',
        title: 'Validation académique',
        subtasks: [
          { id: '5.1.1', text: 'Vérifier les cas particuliers (étudiants bénéficiant d\'aménagements, double diplômes). A placer tout au début', completed: false },
          { id: '5.1.2', text: 'Transmettre la première version du planning aux responsables pédagogiques (professeurs)', completed: false },
          { id: '5.1.3', text: 'Recueillir leurs retours (conflits, erreurs, contraintes non prises en compte)', completed: false }
        ]
      },
      {
        id: '5.2',
        title: 'Intégration des retours',
        subtasks: [
          { id: '5.2.1', text: 'Corriger les conflits entre étudiants, salles ou enseignants', completed: false },
          { id: '5.2.2', text: 'Vérifier la cohérence globale du planning après chaque correction', completed: false },
          { id: '5.2.3', text: 'Gérer les demandes exceptionnelles (changements tardifs, dérogations)', completed: false }
        ]
      }
    ]
  },
  {
    id: 6,
    title: 'Finalisation du planning',
    items: [
      { id: '6.0', text: 'Geler la version finale dans le système', completed: false },
      {
        id: '6.1',
        title: 'Génération des listings',
        subtasks: [
          { id: '6.1.1', text: 'Générer les listings par salle', completed: false },
          { id: '6.1.2', text: 'Générer les listings par enseignant ou surveillant', completed: false }
        ]
      }
    ]
  },
  {
    id: 7,
    title: 'Préparation opérationnelle',
    items: [
      {
        id: '7.1',
        title: 'Communication',
        subtasks: [
          { id: '7.1.1', text: 'Publier le planning auprès des étudiants', completed: false },
          { id: '7.1.2', text: 'Informer les enseignants', completed: false },
          { id: '7.1.3', text: 'Envoyer les convocations automatiques', completed: false }
        ]
      }
    ]
  },
  {
    id: 8,
    title: 'Suivi et mise à jour',
    items: [
      { id: '8.1', text: 'Gérer les modifications de dernière minute (absences, salles indisponibles)', completed: false },
      { id: '8.2', text: 'Maintenir un historique horodaté des modifications', completed: false },
      { id: '8.3', text: 'Mettre à jour les listes et documents automatiquement en cas de changement', completed: false },
      { id: '8.4', text: 'Communiquer les mises à jour aux parties prenantes', completed: false }
    ]
  },
  {
    id: 9,
    title: 'Clôture et archivage',
    items: [
      { id: '9.1', text: 'Archiver les plannings par semestre', completed: false },
      { id: '9.2', text: 'Archiver les allocations de salles et de surveillants', completed: false },
      { id: '9.3', text: 'Exporter les rapports destinés à l\'administration', completed: false },
      { id: '9.4', text: 'Préparer un bilan de session pour l\'amélioration continue', completed: false }
    ]
  },
  {
    id: 10,
    title: 'NOTES',
    items: [
      { id: '10.1', text: 'Insertion des notes', completed: false },
      { id: '10.2', text: 'Validation des notes par les profs', completed: false },
      { id: '10.3', text: 'Transmission des notes', completed: false }
    ]
  }
]

function ExamChecklist() {
  const [checklist, setChecklist] = useState(() => {
    // Charger l'état sauvegardé depuis localStorage
    const saved = localStorage.getItem('examChecklist')
    return saved ? JSON.parse(saved) : CHECKLIST_DATA
  })

  const [expandedSections, setExpandedSections] = useState({})
  const [showStats, setShowStats] = useState(true)

  // Sauvegarder dans localStorage à chaque changement
  useEffect(() => {
    localStorage.setItem('examChecklist', JSON.stringify(checklist))
  }, [checklist])

  // Calculer les statistiques
  const calculateStats = () => {
    let total = 0
    let completed = 0

    checklist.forEach(section => {
      section.items.forEach(item => {
        if (item.subtasks) {
          item.subtasks.forEach(subtask => {
            total++
            if (subtask.completed) completed++
          })
        } else {
          total++
          if (item.completed) completed++
        }
      })
    })

    return { total, completed, percentage: total > 0 ? Math.round((completed / total) * 100) : 0 }
  }

  // Toggle une tâche simple
  const toggleTask = (sectionId, itemId) => {
    setChecklist(prev => prev.map(section => {
      if (section.id === sectionId) {
        return {
          ...section,
          items: section.items.map(item => {
            if (item.id === itemId) {
              return { ...item, completed: !item.completed }
            }
            return item
          })
        }
      }
      return section
    }))
  }

  // Toggle une sous-tâche
  const toggleSubtask = (sectionId, itemId, subtaskId) => {
    setChecklist(prev => prev.map(section => {
      if (section.id === sectionId) {
        return {
          ...section,
          items: section.items.map(item => {
            if (item.id === itemId && item.subtasks) {
              return {
                ...item,
                subtasks: item.subtasks.map(subtask => {
                  if (subtask.id === subtaskId) {
                    return { ...subtask, completed: !subtask.completed }
                  }
                  return subtask
                })
              }
            }
            return item
          })
        }
      }
      return section
    }))
  }

  // Toggle l'expansion d'une section
  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }))
  }

  // Réinitialiser la checklist
  const resetChecklist = () => {
    if (window.confirm('Êtes-vous sûr de vouloir réinitialiser toute la checklist ?')) {
      setChecklist(CHECKLIST_DATA)
      localStorage.removeItem('examChecklist')
    }
  }

  // Exporter la checklist
  const exportChecklist = () => {
    const dataStr = JSON.stringify(checklist, null, 2)
    const dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr)
    const exportFileDefaultName = `checklist-examens-${new Date().toISOString().split('T')[0]}.json`

    const linkElement = document.createElement('a')
    linkElement.setAttribute('href', dataUri)
    linkElement.setAttribute('download', exportFileDefaultName)
    linkElement.click()
  }

  const stats = calculateStats()

  return (
    <div className="w-full max-w-5xl mx-auto">
      <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
        <div className="flex justify-between items-start mb-6">
          <div>
            <h2 className="text-3xl font-bold text-indigo-900 mb-2">
              Checklist Gestion des Examens
            </h2>
            <p className="text-gray-600">
              Suivez toutes les étapes de la planification et gestion des examens
            </p>
          </div>

          <div className="flex gap-2">
            <button
              onClick={() => setShowStats(!showStats)}
              className="px-4 py-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors text-sm font-medium"
            >
              {showStats ? 'Masquer stats' : 'Afficher stats'}
            </button>
            <button
              onClick={exportChecklist}
              className="px-4 py-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors text-sm font-medium"
            >
              Exporter
            </button>
            <button
              onClick={resetChecklist}
              className="px-4 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors text-sm font-medium"
            >
              Réinitialiser
            </button>
          </div>
        </div>

        {showStats && (
          <div className="bg-gradient-to-r from-indigo-50 to-blue-50 rounded-lg p-4 mb-6">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-semibold text-gray-700">Progression globale</span>
              <span className="text-2xl font-bold text-indigo-600">{stats.percentage}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-3 mb-2">
              <div
                className="bg-gradient-to-r from-indigo-500 to-blue-500 h-3 rounded-full transition-all duration-500"
                style={{ width: `${stats.percentage}%` }}
              />
            </div>
            <div className="flex justify-between text-sm text-gray-600">
              <span>{stats.completed} tâches complétées</span>
              <span>{stats.total - stats.completed} restantes</span>
            </div>
          </div>
        )}

        <div className="space-y-4">
          {checklist.map((section) => {
            const isExpanded = expandedSections[section.id] !== false

            return (
              <div key={section.id} className="border border-gray-200 rounded-lg overflow-hidden">
                <button
                  onClick={() => toggleSection(section.id)}
                  className="w-full px-4 py-3 bg-gradient-to-r from-indigo-50 to-blue-50 hover:from-indigo-100 hover:to-blue-100 transition-colors flex items-center justify-between"
                >
                  <div className="flex items-center gap-3">
                    <span className="flex items-center justify-center w-8 h-8 bg-indigo-600 text-white rounded-full font-bold text-sm">
                      {section.id}
                    </span>
                    <span className="font-bold text-gray-800 text-left">{section.title}</span>
                  </div>
                  <svg
                    className={`w-5 h-5 text-gray-600 transition-transform ${isExpanded ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                {isExpanded && (
                  <div className="p-4 bg-white space-y-3">
                    {section.items.map((item) => (
                      <div key={item.id} className="ml-4">
                        {item.subtasks ? (
                          <div>
                            <div className="font-semibold text-gray-700 mb-2 flex items-center gap-2">
                              <span className="text-indigo-600">{item.id}.</span>
                              {item.title}
                            </div>
                            <div className="ml-6 space-y-2">
                              {item.subtasks.map((subtask) => (
                                <label
                                  key={subtask.id}
                                  className="flex items-start gap-3 cursor-pointer group"
                                >
                                  <input
                                    type="checkbox"
                                    checked={subtask.completed}
                                    onChange={() => toggleSubtask(section.id, item.id, subtask.id)}
                                    className="mt-1 w-4 h-4 text-indigo-600 rounded focus:ring-indigo-500 cursor-pointer"
                                  />
                                  <span className={`text-gray-700 group-hover:text-indigo-600 transition-colors ${
                                    subtask.completed ? 'line-through text-gray-400' : ''
                                  }`}>
                                    <span className="text-sm text-gray-500 font-mono mr-2">{subtask.id}</span>
                                    {subtask.text}
                                  </span>
                                </label>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <label className="flex items-start gap-3 cursor-pointer group">
                            <input
                              type="checkbox"
                              checked={item.completed}
                              onChange={() => toggleTask(section.id, item.id)}
                              className="mt-1 w-4 h-4 text-indigo-600 rounded focus:ring-indigo-500 cursor-pointer"
                            />
                            <span className={`text-gray-700 group-hover:text-indigo-600 transition-colors ${
                              item.completed ? 'line-through text-gray-400' : ''
                            }`}>
                              <span className="text-sm text-gray-500 font-mono mr-2">{item.id}</span>
                              {item.text}
                            </span>
                          </label>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )
          })}
        </div>

        <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <div className="flex items-start gap-3">
            <svg className="w-5 h-5 text-yellow-600 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            <div className="text-sm text-yellow-800">
              <p className="font-semibold mb-1">Note importante</p>
              <p>Votre progression est automatiquement sauvegardée dans le navigateur. Utilisez le bouton "Exporter" pour sauvegarder une copie de votre checklist.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExamChecklist
